// Email validation utility
export const isValidEmail = (email) => {
	const validateEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return validateEmail.test(email);
};
